/* eslint-disable */
import jwt_decode from "jwt-decode";

export default {
    getUserNameFromToken,
    getUserIDFromToken,
    getRoleFromToken,
    isTokenExists,
    getToken,
    getGroupFactoryToken,
    getRoleIDFromToken,
    getRoleLevelFromToken,
    getFactoryTypeFromToken
}

function getUserNameFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.given_name;
    }
    return "";
}

function getUserIDFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.nameid;
    }
    return "";

}

function getRoleFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.roleName;
    }
    return "";

}


function getGroupFactoryToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        let data = {
            group: decoded.groupID,
            factory: decoded.factoryID
        }
        return data;
    }
    return "";

}

function isTokenExists() {
    var token = sessionStorage.getItem('token');

    if (token == null || token == undefined || token === "") {
        return false;
    }

    return true;
}

function getToken() {
    var token = sessionStorage.getItem('token');
    return token;
}

function getRoleIDFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.roleID;
    }
    return "";
}

function getRoleLevelFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.roleLevel;
    }
    return "";
}

function getFactoryTypeFromToken() {
    var token = sessionStorage.getItem('token');
    if (token != "" || token != null || token != undefined) {
        var decoded = jwt_decode(token);
        return decoded.factoryType;
    }
    return "";
}